import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import axios from "axios";
import {
  FORGOT_PASSWORD,
  FORGOT_PASSWORD_CHECK,
  FORGOT_PASSWORD_RESET,
} from "../actions/types";
import {
  forgotPasswordSuccess,
  forgotPasswordCheckSuccess,
  forgotPasswordResetSuccess,
  forgotPasswordSetToken,
  requestResetOpenSuccess,
  requestResetOpenFail,
  resetOpenSuccess,
  resetOpenFail,
} from "../actions/ForgotPasswordActions";
import { showErrorMessage } from "../actions/NotifyActions";
//import { getErrorMessage } from "../utils/apiUtil";
import { setInitUrl } from "../actions";
import axiosRetry from "axios-retry";
import { authorizationHeader, getErrorMessage_v2 } from "../utils/apiUtil";
axiosRetry(axios, {
  retries: 3,
  retryDelay: (retryCount) => {
    return retryCount * 1000;
  },
});

const REACT_APP_API_URL = process.env.REACT_APP_API_URL;

// API

const authenAccesstoken = async (payload) => {
  ////Quickly implement !!!!
  const res = await axios.post(
    `${REACT_APP_API_URL}/v1/acare/auth/access-token`,
    {
      client_id: "2AD5G",
      channel_secret: "f8808d2cf2fafb44212c26696a35c12f",
    }
  );

  localStorage.setItem(
    "member",
    JSON.stringify({
      token: res.data.access_token,
      tokenType: res.data.token_type,
    })
  );
};

const forgotPasswordRequest = async ({ email }) => {
  return await axios
    .post(
      `${REACT_APP_API_URL}/v1/acare/forgot-password`,
      {
        email,
      },
      {
        headers: authorizationHeader("Bearer"),
      }
    )
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};

const forgotPasswordCheckRequest = async (token) => {
  return await axios
    .post(
      `${REACT_APP_API_URL}/v1/acare/check-reset-token`,
      {
        token,
      },
      {
        headers: authorizationHeader("Bearer"),
      }
    )
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};

const forgotPasswordResetRequest = async ({ token, new_password }) => {
  return await axios
    .post(
      `${REACT_APP_API_URL}/v1/acare/reset-password`,
      {
        token,
        new_password,
      },
      {
        headers: authorizationHeader("Bearer"),
      }
    )
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};

// WORKER
function* forgotPassword({ payload }) {
  try {
    yield call(authenAccesstoken);
    const data = yield call(forgotPasswordRequest, payload);
    if (data.success) {
      yield put(forgotPasswordSuccess(data));
      yield put(requestResetOpenSuccess(data.message));
    } else {
      yield put(requestResetOpenFail(data.message));
    }
  } catch (error) {
    yield put(showErrorMessage(getErrorMessage_v2(error.response)));
  }
}

function* forgotPasswordCheck({ payload }) {
  try {
    yield call(authenAccesstoken);
    const data = yield call(forgotPasswordCheckRequest, payload);

    if (data.success) {
      yield put(forgotPasswordSetToken(payload));
      yield put(forgotPasswordCheckSuccess(data.success));
    } else {
      yield put(resetOpenFail(data.message));
    }
  } catch (error) {
    yield put(showErrorMessage(getErrorMessage_v2(error.response)));
    //yield put(setInitUrl("/"));
  }
}

function* forgotPasswordReset({ payload }) {
  try {
    yield call(authenAccesstoken);
    const data = yield call(forgotPasswordResetRequest, payload);
    if (data.success) {
      yield put(forgotPasswordResetSuccess(data));
      yield put(resetOpenSuccess(data.message));
    } else {
      yield put(resetOpenFail(data.message));
    }
  } catch (error) {
    yield put(showErrorMessage(getErrorMessage_v2(error.response)));
  }
}

// WATCHER
export function* forgotPasswordWatcher() {
  yield takeEvery(FORGOT_PASSWORD, forgotPassword);
}

export function* forgotPasswordCheckWatcher() {
  yield takeEvery(FORGOT_PASSWORD_CHECK, forgotPasswordCheck);
}

export function* forgotPasswordResetWatcher() {
  yield takeEvery(FORGOT_PASSWORD_RESET, forgotPasswordReset);
}

export default function* rootSaga() {
  yield all([
    fork(forgotPasswordWatcher),
    fork(forgotPasswordCheckWatcher),
    fork(forgotPasswordResetWatcher),
  ]);
}
